<template>
    <section>
        <Header></Header>
        <div class="body">
            <SectionAboutWelcome/>
            <SectionAboutWelcomeDesc/>
            <SectionAboutWelcomeOrganization/>
            <SectionAboutWelcomeMap/>
        </div>
        <Footer></Footer>
    </section>
</template>

<script>
    import Header from '../components/Header.vue'
    import Footer from '../components/Footer.vue'
    import SectionAboutWelcome from '../components/SectionAboutWelcome.vue'
    import SectionAboutWelcomeDesc from '../components/SectionAboutWelcomeDesc.vue'
    import SectionAboutWelcomeOrganization from '../components/SectionAboutWelcomeOrganization.vue'
    import SectionAboutWelcomeMap from '../components/SectionAboutWelcomeMap.vue'
    import loginService from '../services/loginService'
    import client from "../client/client"

    export default {
        name: "Main",
        components: {
            Header,
            Footer,
            SectionAboutWelcome,
            SectionAboutWelcomeDesc,
            SectionAboutWelcomeOrganization,
            SectionAboutWelcomeMap
        },
        data: function () {
            return {
                success: false,
                loginErrorMsg: "",
                username: "",
                password: "",
            }
        },
        mounted() {
            
        },
        methods: {
            async login() {
                if(!this.username || !this.password)
                    return;

                const result = await loginService.login(this.username, this.password);
                if (result.r) {
                    this.success = true;
                    this.loginErrorMsg = '';
                } else {
                    this.success = false;
                    this.loginErrorMsg = result.msg;
                }
                console.log(result)

            }
        }
    }
</script>

<style scoped>

</style>
